import { ActionType } from "../types";
import { UserIDs, UserIDAction } from "../types/user_ids";

export function user_ids(state: UserIDs = {}, action: UserIDAction): UserIDs {
  switch (action.type) {
    case ActionType.GET_USER_ID_REQUEST:
      return {
        ...state,
        [action.email]: null,
      };
    case ActionType.GET_USER_ID_SUCCESS:
      return {
        ...state,
        [action.email]: action.user_id,
      };
    case ActionType.GET_USER_ID_FAILURE:
      return {
        ...state,
        [action.email]: null,
      };
    default:
      return state;
  }
}
